import { Component, OnInit, Renderer2, ElementRef, ViewChildren, ViewChild, QueryList, ChangeDetectorRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { logbaseService } from '../../services/logbase.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { formDialogService } from "../../services/formDialogService";
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: 'app-line-number',
  templateUrl: './line-number.component.html',
  styleUrls: ['./line-number.component.scss']
})
export class LineNumberComponent implements OnInit {
  processNameJp: any;
  navigateAfterSave: boolean = true;
  lineNumberList_Deleted: any;
  lineNumberListDeleted: any;
  lineNumberList_notDeleted: any;
  exportdata: any = [];
  newData: any;
  newNextProcessExport: any;
  updateEngName: any;
  updateJapName: any;
  nextProcessGroupVal: any;
  missingNPData: any;
  missingNP: any;
  openPopupBox: boolean;
  PopupData: any;
  lineNumber: any;
  plantName: any;
  missingList: any;
  list: any;
  half: number;
  secondTable: any;
  firstTable: any;
  firstList: void;
  listLength: any;
  lineNumberList: any;
  plantMissing: any;
  japNameMissing: any;
  engNameMissing: any;
  searchTextDeleted: any;
  nextProcessJp: any;
  srchValue:any;
  @ViewChild('createNav') createNav: ElementRef;
  @ViewChild('createPane') createPane: ElementRef;
  @ViewChild('unlistNav') unlistNav: ElementRef;
  @ViewChild('unlistPane') unlistPane: ElementRef;
  @ViewChild('newProcessNav') newProcessNav: ElementRef;
  @ViewChild('newProcessPane') newProcessPane: ElementRef;
  @ViewChildren(DataTableDirective)
  modalRef: NgbModalRef;
  searchText: any;
  public rows: Array<any> = [];
  public columns: Array<any> = [
    { title: 'New Next Process', name: 'newNextProcess' },
    { title: 'Add Next Process', name: 'addInfo' },
  ];
  public page: number = 1;
  public itemsPerPage: number = 100;
  public maxSize: number = 100;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };

  private data: Array<any> = [];
  operationsGNumberList = ["HO (Higashi Ogishima)", "K1", "CCJ", "Nakatsu", "Atsugi", "Toyama"];
  constructor(private logbaseService: logbaseService, private ref: ChangeDetectorRef, private formDialogService: formDialogService,
    private toaster: ToastrService, private renderer: Renderer2, private spinner: NgxSpinnerService, private modalService: NgbModal, private translate: TranslateService) { }

  ngOnInit() {
    this.spinner.show();
    this.searchText = '';
    this.onChangeTable(this.config, true);
    // this.getUnlistedLineNumbers();
    this.getListofLineNumbers();
    this.getListofLineNumbersDeleted();
  }

  // getUnlistedLineNumbers() {
  //   let datasend = {
  //     "pageNum": 0,
  //     "searchValue": "",
  //     "size": 10,
  //     "sortColumn": "",
  //     "sortType": ""
  //   }
  //   this.spinner.show();
  //   this.logbaseService.getMissingLineNumbers(datasend).subscribe(
  //     result => {
  //       let res: any;
  //       res = result.response.content;
  //       this.missingList = res;
  //       this.getListofLineNumbers();
  //     });
  // }


  getListofLineNumbers() {
    let nextProcess_notdeleted = "notdeleted"
    this.logbaseService.getAvailableNextProcess(nextProcess_notdeleted).subscribe(
      result => {
        this.lineNumberList = result;
        this.lineNumberList_notDeleted = this.lineNumberList.response;
        this.spinner.hide();
      }
    )
  }

  getListofLineNumbersDeleted() {
    let nextProcess_deleted = "deleted"
    this.logbaseService.getAvailableNextProcess(nextProcess_deleted).subscribe(
      result => {
        this.lineNumberListDeleted = result;
        this.lineNumberList_Deleted = this.lineNumberListDeleted.response;
        this.spinner.hide();
      }
    )
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (item[column.name].toString().match(this.config.filtering.filterString)) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    var pageNo;
    var sortData;
    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }
    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value.name,
          sort: value.sort
        }
      }
    });
    var dataToSend = {
      pageNum: pageNo,
      //searchValue: this.config.filtering.filterString,
      searchValue:this.srchValue,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
    }

    this.spinner.show();
    this.logbaseService.getMissingLineNumbers(dataToSend)
      .subscribe(result => {
        this.missingNP = result;
        this.missingNPData = this.missingNP.response.content;
        this.spinner.hide();
        var partArr;
        var partsData = [];
        // this.missingNP.response.content.forEach(function (value, key) {
        //   partArr = {
        //     newNextProcess: value.lineNumber,
        //     addInfo: '<td class="text-center hasLink">' + '<i class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i> ' + 'Add Next Process' + '</td>'
        //   };
        //   partsData.push(partArr);
        // });
        this.data = partsData;
        this.length = this.missingNP.response.totalElements;
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        //this.length = sortedData.length;
        this.rerenderTable(this.config, true);
        this.ref.detectChanges();
      });
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
  }

  // rerender() {
  //   this.spinner.show()
  //   this.logbaseService.getListofLineNumbers().subscribe(
  //     result => {
  //       this.lineNumberList = result.response;
  //       this.spinner.hide();
  //     });

  // let datasend = {
  //   "pageNum": 0,
  //   "searchValue": "",
  //   "size": 10,
  //   "sortColumn": "",
  //   "sortType": ""
  // }
  // this.logbaseService.getMissingLineNumbers(datasend).subscribe(
  //   result => {
  //     let res: any;
  //     res = result.response.content;
  //     this.missingList = res;
  //     this.spinner.hide();
  //   });
  // }
  onChange(group) {
    this.plantMissing = group;
  }
  onChangeJP(value) {
    this.japNameMissing = value
  }

  onChangeEN(value) {
    this.engNameMissing = value;
  }


  // addToListed(item) {
  //   let addPlantToNextProcess = {
  //     "groupNumber": item.groupNumber,
  //     "lineNumber": item.lineNumber,
  //   }
  //   Object.assign(addPlantToNextProcess, this.openPopupBox ? { groupNumber: item.groupNumber } : { groupNumber: item.missing });
  //   this.logbaseService.addLineNumber(addPlantToNextProcess).subscribe(
  //     response => {
  //       let updatemissing = { "lineNumber": item.lineNumber, "missing": false }
  //       this.logbaseService.addLineNumberMissing(updatemissing).subscribe(
  //         response => {
  //           // this.getUnlistedLineNumbers();
  //           this.toaster.success(item.lineNumber + ' successfully added');
  //           this.modalRef.close();
  //         }
  //       )
  //     }
  //   )
  // }

  addNewNextProcess(item) {
    let addPlantToNextProcess = {
      "groupNumber": this.plantMissing,
      "lineNumber": item.lineNumber,
      "processNameEn": this.engNameMissing,
      "processNameJp": this.japNameMissing,
      "status": "not_deleted"
    }
    this.logbaseService.addLineNumber(addPlantToNextProcess).subscribe(
      response => {
        let updatemissing = { "lineNumber": item.lineNumber, "missing": false }
        this.logbaseService.addLineNumberMissing(updatemissing).subscribe(
          response => {
            // this.getUnlistedLineNumbers();
            this.toaster.success(item.lineNumber + this.translate.instant('successfully added'));
            this.onChangeTable(this.config, true);
            this.getListofLineNumbers();
          }
        )
      }
    )
  }


  onChangeGroup(value) {
    this.nextProcessGroupVal = value
  }

  onChangeJapName(value) {
    this.updateJapName = value
  }

  onChangeEngName(value) {
    this.updateEngName = value
  }

  saveNextProcess(value) {
    this.spinner.show();
    let addPlantToNextProcess = {
      "groupNumber": this.nextProcessGroupVal,
      "lineNumber": value.lineNumber,
      "processNameEn": this.updateEngName,
      "processNameJp": this.updateJapName,
      "status": "not_deleted"
    }
    this.logbaseService.addLineNumber(addPlantToNextProcess).subscribe(
      response => {
        this.spinner.hide();
        this.toaster.success(value.lineNumber + ' successfully added');
        this.getListofLineNumbers();
        // this.navigateAfterSave = false;
      });
  }

  deleteNextProcess(data) {
    this.spinner.show();
    let updateStatus = {
      "groupNumber": data.groupNumber,
      "lineNumber": data.lineNumber,
      "processNameEn": data.processNameEn,
      "processNameJp": data.processNameJp,
      "status": "deleted"
    }

    this.logbaseService.updateNextProcessStatus(updateStatus).subscribe(
      response => {
        this.spinner.hide();
        this.toaster.success(data.lineNumber + 'deleted successfully');
        this.getListofLineNumbers();
        this.getListofLineNumbersDeleted();
        // this.navigateAfterSave = false;
      }
    )
  }

  undoDelete(data) {
    this.spinner.show();
    let updateStatus = {
      "groupNumber": data.groupNumber,
      "lineNumber": data.lineNumber,
      "processNameEn": data.processNameEn,
      "processNameJp": data.processNameJp,
      "status": "notdeleted"
    }
    this.logbaseService.updateNextProcessStatus(updateStatus).subscribe(
      response => {
        this.spinner.hide();
        this.toaster.success(data.lineNumber + 'deleted successfully');
        this.getListofLineNumbers();
        this.getListofLineNumbersDeleted();
      }
    )
  }

  // openPopup(addNextProcess, lineNumber, plant, row, listed){
  //   this.openPopupBox = listed;
  //   this.plantName = plant;
  //   this.lineNumber = lineNumber;
  //   this.PopupData = row;
  //   this.modalRef = this.modalService.open(addNextProcess, { backdrop: false });
  // }


  // canDeactivate() {
  //   if (this.navigateAfterSave == true) {
  //     return this.formDialogService.confirm();
  //   }
  //   return true;
  // }

  public exportNewNPcsv(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    var pageNo;
    var sortData;
    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }

    if (config ? config.filtering : '') {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config ? config.sorting : '') {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value.name,
          sort: value.sort
        }
      }
    });
    var dataToSend = {
      pageNum: pageNo,
      searchValue: this.config.filtering.filterString,
      size: this.length,
      sortColumn: sortData.name,
      sortType: sortData.sort,
    }

    this.logbaseService.getMissingLineNumbers(dataToSend)
      .subscribe(result => {
        this.newNextProcessExport = result.response.content;
      });
    let exportdata = [];
    if (this.newNextProcessExport != undefined) {
      this.newNextProcessExport.forEach(element => {
        var obj = {}
        obj["lineNumber"] = element.lineNumber
        exportdata.push(obj);
      });
      var options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: false,
        headers: ['Next Process']
      };
      new AngularCsv(exportdata, 'New Next Process', options);
    }
  }
  exportCSV() {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: ['Next Process', 'Plant Name', 'Process Name [Eng]', 'Process Name [Jap]', 'Status']
    };
    new AngularCsv(this.lineNumberList_notDeleted, 'Available Next Process', options);
  }
}
